import { useQuery } from "@tanstack/react-query";

import { getProvinces } from "../../services/provinces";

const useGetProvinces = () => {
    return useQuery({
        queryKey: ['provinces'],
        queryFn: getProvinces,
        staleTime: Infinity,
        retry: 0,
    });
};

export default useGetProvinces;